import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './grid.module.css'

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    htmlElement: PropTypes.string,
    lg: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    md: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    style: PropTypes.object // eslint-disable-line react/forbid-prop-types
}

const defaultProps = {
    htmlElement: 'div',
    size: 12
}

/**
 * Rendering a responsive grid column.
 *
 * @param {Array|string} [props.children] - The container child elements
 * @param {string} [props.className] - The additional className for this component
 * @param {string} [props.style] - The additional style for this component
 * @param {string} [props.htmlElement='div'] - The html element to be rendered
 * @param {string|number} [props.size=12] - The none responsive column width based on 12 columns grid
 * @param {string|number} [props.sm] - The responsive small screen column width based on 12 columns grid
 * @param {string|number} [props.md] - The responsive medium screen column width based on 12 columns grid
 * @param {string|number} [props.lg] - The responsive large screen column width based on 12 columns grid
 * @returns {ReactElement}
 */
function GridCol(props) {
    const { children, className, htmlElement: HtmlElement, lg, md, size, sm, style } = props
    const composedClassName = cx(
        styles[`col-${size}`],
        {
            [styles[`col-sm-${sm}`]]: sm,
            [styles[`col-md-${md}`]]: md,
            [styles[`col-lg-${lg}`]]: lg
        },
        className
    )

    return (
        <HtmlElement className={composedClassName} style={style}>
            {children}
        </HtmlElement>
    )
}

GridCol.propTypes = propTypes
GridCol.defaultProps = defaultProps

export default GridCol
